/**
 * Seed data for the dev mock patient (code 100010).
 * Used to populate users/{uid} healthRecords so check-in and ChartMind have a full CMR.
 * Shape matches getPatientCMRWithHistory / getNormalizedPatientData expectations.
 */

import { SAMPLE_PATIENTS } from './cmrMocks';

const SOURCE = SAMPLE_PATIENTS['patient-001'];

/**
 * Returns the Firestore merge payload to seed the mock patient's CMR.
 * Merge into users/{uid} so role/name from dev auth are preserved.
 * @returns {Object} { healthRecords, name, dob, email, phone }
 */
export function getMockPatientSeedForFirestore() {
  return {
    healthRecords: {
      firstName: SOURCE.firstName || SOURCE.name?.split(' ')[0] || '',
      lastName: SOURCE.lastName || SOURCE.name?.split(' ').slice(1).join(' ') || '',
      dateOfBirth: SOURCE.dateOfBirth || SOURCE.dob || null,
      sex: SOURCE.sex || SOURCE.gender || null,
      email: SOURCE.email || null,
      phone: SOURCE.phone || null,
      address: SOURCE.address || null,
      emergencyContact: SOURCE.emergencyContact || null,
      medications: SOURCE.medications || [],
      allergies: SOURCE.allergies || [],
      pmh: SOURCE.pmh || [],
      psh: SOURCE.psh || [],
      familyHistory: SOURCE.other?.familyHistory || null,
      socialHistory: SOURCE.other?.socialHistory || null,
      ...(SOURCE.other && typeof SOURCE.other === 'object' ? { other: SOURCE.other } : {}),
    },
    name: SOURCE.name || null,
    dob: SOURCE.dob || SOURCE.dateOfBirth || null,
    email: SOURCE.email || null,
    phone: SOURCE.phone || null,
  };
}

export default getMockPatientSeedForFirestore;
